/*
 * xmljson
 * https://github.com/ExactTarget/node-xmljson
 *
 * Copyright (c) 2013 ExactTarget
 * Licensed under the MIT license.
 */

module.exports = {
	to_json: require('./to_json'),
	to_xml: require('./to_xml')
};
